export const getModules = (state) => {
    return state.modules;
};
export const getQuestions = (state) => {
    return state.questions;
};
export const getChoices = (state) => {
    return state.choices;
};
export const getQuestionnaire = (state) => {
    return state.questionnaire;
};
export const getAboutUs = (state) => {
    return state.aboutUs;
};
export const getPrivacyPolicy = (state) => {
    return state.privacyPolicy;
};
export const getSlogans = (state) => {
    return state.slogans;
};
export const getAwards = (state) => {
    return state.awards;
};
export const getUser = (state) => {
    return state.user
}

export const getModule = (state) => {
    return keyword => state.modules.find(item => {
        return item.name == keyword
    });
}